import { maxAttachmentSize } from 'src/app/core/constants/mail-box-const';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Editor, Toolbar, Validators } from 'ngx-editor';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { EmailRegex } from 'src/app/core/constants/dropdown-contants';
import {
    decodeHtml,
    getMailDraftEditBody,
    getMailReplyFormat,
    getSignatureWithData,
} from 'src/app/core/helpers/helperfunc';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { saveAs } from 'file-saver';
import { MailCommon, MailTypeIds } from 'src/app/core/constants/mail-box-const';
import { EmailWarningPopupComponent } from '../shared/email-warning-popup/email-warning-popup.component';
import { EmailEditorComponent } from 'angular-email-editor';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { SummernoteEditorComponent } from 'src/app/core/shared-modules/components/summernote-editor/summernote-editor.component';

@Component({
    selector: 'app-create-mail',
    templateUrl: './create-mail.component.html',
    styleUrls: ['./create-mail.component.scss'],
})
export class CreateMailComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(SummernoteEditorComponent) summernoteEditor: SummernoteEditorComponent;
    @ViewChild('toInput') toInput: ElementRef<HTMLInputElement>;
    @Input() email_data: any = null;
    @Input() isFullScreen: boolean = false;
    @Input() isGlobalMailBox: boolean = false;
    @Input() showCompose: boolean = false;
    @Output() toggleShowCompose: EventEmitter<boolean> = new EventEmitter();
    @Output() trigger_reload: EventEmitter<any> = new EventEmitter();
    @ViewChild('mailContainer') mailContainer: ElementRef = new ElementRef({});
    private keydownSubject = new Subject<{
        inputValue: string;
        type: string;
    }>();
    isLoading: { [key: string]: boolean } = {
        to: false,
        cc: false,
        bcc: false,
    };
    user_details: any;
    compose_email_form: FormGroup;
    editor: Editor;
    toolbar: Toolbar = [
        // default value
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
        ['link', 'image'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
        ['horizontal_rule', 'format_clear'],
    ];
    private _unsubscribeAll: Subject<any> = new Subject();
    getMailReplyFormat = getMailReplyFormat;
    reply_hidden_content: any;
    see_original_mail: boolean = false;
    is_submitted: boolean = false;
    upload_files: any[] = [];

    public validators = [this.startsWithAt];
    customValidators = [
        this.startsWithAt,
        this.forbiddenDomainValidator(/@crizac\.com$/),
    ];
    public errorMessages = {
        invalidmail: 'Invalid email',
    };
    is_cc: boolean = false;
    is_bcc: boolean = false;
    default_attachment: any;
    align_inbox_mail: any;
    mail_common = MailCommon;
    is_discard: boolean = false;
    is_subject_missing: boolean = false;
    mail_type_ids = MailTypeIds;
    paramsForMail: any;
    getMailDraftEditBody = getMailDraftEditBody;
    decodeHtml: any = decodeHtml;
    suggestions: string[] = [];
    createMailWindowState: boolean = false;
    minimized: boolean = false;
    suggestionsForCC: string[] = [];
    suggestionsForBCC: string[] = [];
    maxAttachmentSize: number = maxAttachmentSize;

    suggestionPaginationConfig: PaginationType = {
        size: 5,
        total: 0,
        skip: 0,
        limit: 5,
    };

    config: any = {
        placeholder: '',
        tabsize: 2,
        height: '500px',
        // uploadImagePath: '/api/upload',
        shortcuts: false, // Disable keyboard shortcuts
        spellCheck: true, // Enable spellcheck
        disableGrammar: false, // Grammar should be enabled (default behavior)
        toolbar: [
            // ['misc', ['codeview', 'undo', 'redo']],
            // ['style', ['bold', 'italic', 'underline', 'clear']],
            [
                'font',
                [
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'superscript',
                    'subscript',
                    'clear',
                ],
            ],
            ['fontsize', ['fontname', 'fontsize', 'color']],
            // ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
            ['para', ['ul', 'ol', 'paragraph']],
            // ['insert', ['table', 'picture', 'link', 'video', 'hr']]
            ['insert', ['picture', 'link']],
        ],
        fontNames: [
            'Helvetica',
            'Arial',
            'Arial Black',
            'Comic Sans MS',
            'Courier New',
            'Roboto',
            'Times',
        ],
    };

    @ViewChild(EmailEditorComponent)
    private emailEditor: EmailEditorComponent;

    separatorKeysCodes: number[] = [ENTER, COMMA];
    mailExtension: string;
    mailDynamicData: any;
    allMailSignatures: any;
    constructor(
        // public dialogRef: MatDialogRef<CreateMailComponent>,
        // @Inject(MAT_DIALOG_DATA) public email_data: any,
        private _authService: AuthenticationService,
        private _loaderService: LoaderService,
        private _fb: FormBuilder,
        private _toasterService: ToasterService,
        private _universitycommunicationService: UniversityCommunicationService,
        private _dialog: MatDialog,
        private renderer: Renderer2,
        private _lc: LocalStorageService,
        private cdr: ChangeDetectorRef

    ) {
        this.initiateEmailForm();
        this.user_details = this._authService.getLoginUserDetails();
        this.allMailSignatures = this._lc.getUserMailDetails();
        // this.email_data = ''
    }

    get formData() {
        return this.compose_email_form.controls
    }

    editorLoaded(event) {
        this.emailEditor.loadDesign(
            this.decodeHtml(
                getSignatureWithData(this.email_data, this.user_details, this.mailDynamicData)
            )
        );
        // load the design json here
        // this.emailEditor.editor.loadDesign({});
    }

    // called when the editor has finished loading
    editorReady(event) {
        console.log('editorReady');
    }

    ngOnInit(): void {
        let selectedDomain = JSON.parse(
            localStorage.getItem(MailCommon.selected_domain)
        );
        this.generateSig(selectedDomain?.mail);
        this.keydownSubject
            .pipe(debounceTime(500))
            .subscribe(({ inputValue, type }) => {
                this.getMailSuggestions(inputValue, type);
            });
        this.editor = new Editor();
        this.align_inbox_mail = this.user_details?.inboxMail.filter((email) => {
            return email?.externalEmailAccess === "false" || email?.isPersonal === "true" || email?.externalEmailAccess === "true"//? changed for showing the error pop line:306
        })
        if (this.user_details?.composeEmailIds) {
            const composeEmailIds: any = this.user_details?.composeEmailIds.split(',');
            if (composeEmailIds.length > 0) {
                const emailIds = composeEmailIds.map((item) => {
                    return {
                        mail: item,
                        externalEmailAccess: "true",
                        isComposeEmail: true,
                        domain: item.split('@')[1]?.toLowerCase()
                    }
                })
                this.align_inbox_mail = [
                    ...this.align_inbox_mail,
                    ...emailIds
                ]
            }
        }
        if (
            this.email_data?.type === 'forward' ||
            this.email_data?.type === 'draftedit'
        ) {
            this.default_attachment = [
                ...this.email_data?.mail_details?.attachments,
            ];
        }
        this.formControls['from'].valueChanges.pipe(distinctUntilChanged(),
            debounceTime(300)).subscribe({
                next: (res) => {
                    if (res) {
                        this.externalEmailAccessCheck();
                        this.forceRevalidation();
                    }
                }
            })
        this.patchValuesOnReFw();
        this.switchMailListener();
        this.externalEmailAccessCheck();
    }

    forceRevalidation(): void {
        const emailControls = ['to', 'cc', 'bcc'];
        emailControls.forEach((controlName) => {
            const control = this.formControls[controlName];
            if (control) {
                // Force revalidation of the control
                control.updateValueAndValidity({ emitEvent: true });
            }
        });
    }

    externalEmailAccessCheck() {
        const emailControls = ['to', 'cc', 'bcc'];
        emailControls.forEach((controlName) => {
            const control = this.formControls[controlName];
            if (control) {
                this.checkMailAllow(controlName, emailControls);
            }
        });
    }

    checkMailAllow(controlName: string, allControls: string[]): void {
        this.formControls[controlName].valueChanges
            .pipe(
                distinctUntilChanged(),
                debounceTime(300)
            )
            .subscribe({
                next: (res) => {
                    if (!res) return;

                    const allowExternalMail = this.isAllowExternalMail();
                    let filteredMails = res;

                    // Restrict emails to the 'crizac.com' domain if external email is not allowed
                    if (!allowExternalMail) {
                        filteredMails = res.filter((item) => {
                            const domain = item.split('@')[1]?.toLowerCase();
                            if (domain !== 'crizac.com') {
                                this._toasterService.showWarnig(
                                    'Warning!',
                                    `You can't send mail to external emails.`
                                );
                            }
                            return domain === 'crizac.com';
                        });
                    }

                    // Get the total count of emails across all controls
                    const allEmails = allControls
                        .map((name) => this.formControls[name]?.value || [])
                        .flat();
                    const totalEmails = allEmails.length;

                    // Validate total count
                    if (totalEmails > 50) {
                        this._toasterService.showWarnig(
                            'Limit Exceeded!',
                            `You can only send mail to a maximum of 50 recipients in total.`
                        );

                        // Trim the current control's emails to keep the total <= 10
                        const allowedEmails = Math.max(10 - (totalEmails - filteredMails.length), 0);
                        filteredMails = filteredMails.slice(0, allowedEmails);
                    }

                    // Update the form control if the emails have changed
                    if (JSON.stringify(res) !== JSON.stringify(filteredMails)) {
                        this.formControls[controlName].setValue(filteredMails, { emitEvent: false });
                        this.formControls[controlName].updateValueAndValidity({ emitEvent: false });
                    }
                },
            });
    }


    ngAfterViewInit(): void {
        // Load default content when the editor initializes
    }

    switchMailListener() {
        let eMail = JSON.parse(localStorage.getItem('selected_domain_mails'));
        this._universitycommunicationService.switchMails$.subscribe(
            (rsv: any) => {
                if (rsv?.email?.mail) {
                    if (rsv?.email?.mail !== eMail?.mail) {
                        this.close(true);
                    }
                }
            }
        );
    }

    close(val?: any) {
        if (
            (this.compose_email_form.dirty ||
                this.compose_email_form.controls['to'].dirty) &&
            !this.is_discard
        ) {
            this.openWarningPopup(this.mail_common.discard);
            return;
        } else {
            this.toggleCloseCompose();
        }
        // this.dialogRef.close(val);
    }

    initiateEmailForm() {
        this.compose_email_form = this._fb.group({
            // from: [this.user_details?.email ?? ''],
            from: ['', [Validators.required]],
            to: [[], [Validators.required]],
            cc: [''],
            bcc: [''],
            subject: [''],
            html: [''],
            attachments: [[]],
        });
        this.patchWithSignature();
    }

    patchWithSignature() {
        // console.log(this.user_details?.inboxMail);
        this.compose_email_form?.patchValue({
            html: this.decodeHtml(
                getSignatureWithData(this.email_data, this.user_details, this.mailDynamicData)
            ),
        });
    }

    isAllowExternalMail(): boolean {
        let selectedMail = this.align_inbox_mail.find(
            (element) => element.mail === this.compose_email_form.value.from
        );
        const allowExternalMail = selectedMail?.externalEmailAccess === 'true';
        return allowExternalMail
    }

    filterExternalEmails(emails: string[]): string[] {
        if (!Array.isArray(emails)) return [];
        const isAllowExternalMail = this.isAllowExternalMail();
        if (isAllowExternalMail) return emails;

        const filteredMails = emails.filter(email => {
            if (!email) return false;
            const domain = email.split('@')[1]?.toLowerCase();
            if (domain && domain !== 'crizac.com') {
                return false;
            }
            return true;
        });

        return filteredMails;
    }

    // Modified to handle domain filtering during patching
    patchEmailField(control: string, emails: string[]) {
        if (!emails?.length) return;
        const filteredEmails = this.filterExternalEmails(emails);
        this.compose_email_form.get(control)?.setValue(filteredEmails, { emitEvent: false });
    }

    patchValuesOnReFw() {
        if (this.email_data && Object.keys(this.email_data).length) {
            let selectedDomain = JSON.parse(
                localStorage.getItem(MailCommon.selected_domain)
            );
            if (selectedDomain) {
                if (this.isGlobalMailBox) {
                    this.compose_email_form
                        .get('from')
                        .setValue(this.email_data?.mail_details?.receiptMailId);
                    this.compose_email_form
                        .get('from').updateValueAndValidity();

                } else {
                    this.compose_email_form
                        .get('from')
                        .setValue(selectedDomain?.mail);
                    this.compose_email_form
                        .get('from').updateValueAndValidity();
                }
            }
            const fromMail = this.compose_email_form.get('from')?.value?.trim(); // Get the 'from' email
            // Handle 'reply' type
            if (this.email_data?.type === 'reply') {
                let to_mails = Number(this.email_data?.mail_details?.type) === this.mail_type_ids.sent
                    ? this.email_data?.mail_details.to_mail?.replace(/\s+/g, '').split(',')
                    : this.email_data?.mail_details.from_mail?.replace(/\s+/g, '').split(',');

                // if (fromMail && to_mails?.length) {
                //     to_mails = to_mails.filter(email => email !== fromMail);
                // }
                to_mails = [...new Set(to_mails)];

                if (to_mails?.length) {
                    this.patchEmailField('to', to_mails);
                }
            }

            // Handle 'replyAll' type
            if (this.email_data?.type === 'replyAll') {
                let to_mails = [];
                if (Number(this.email_data?.mail_details?.type) == this.mail_type_ids.sent) {
                    to_mails = this.email_data?.mail_details.to_mail
                        ?.replaceAll(' ', '')
                        .split(',') || [];
                } else if (this.email_data?.mail_details?.from_mail) {
                    to_mails = this.email_data?.mail_details?.from_mail
                        ?.replaceAll(' ', '')
                        .split(',') || [];
                    // ######### reply include the sender mail #########
                    // let otherToMail = this.email_data?.mail_details?.to_mail
                    //     ?.replaceAll(' ', '')
                    //     .split(',') || [];

                    // otherToMail = otherToMail.filter(
                    //     (item) => item !== selectedDomain?.mail
                    // );

                    // if (otherToMail.length > 0) {
                    //     to_mails = [...to_mails, ...otherToMail];
                    // }
                }
                to_mails = [...new Set(to_mails)];
                if (to_mails?.length) {
                    this.patchEmailField('to', to_mails);
                }

                // Handle CC
                if (this.email_data?.mail_details?.cc_mail) {
                    const cc_mails = this.email_data?.mail_details?.cc_mail
                        ?.replaceAll(' ', '')
                        .split(',');
                    if (cc_mails?.length) {
                        this.patchEmailField('cc', cc_mails); // Fixed: was using to_mails instead of cc_mails
                        this.is_cc = true;
                    }
                }

                // Handle BCC
                // if (this.email_data?.mail_details?.bcc_mail) {
                //     const bcc_mails = this.email_data?.mail_details?.bcc_mail
                //         ?.replaceAll(' ', '')
                //         .split(',');
                //     if (bcc_mails?.length) {
                //         this.patchEmailField('bcc', bcc_mails);
                //     }
                // }
            }

            // Handle draft edit
            if (this.email_data?.type === 'draftedit') {
                let to_mails = [];
                if (Number(this.email_data?.mail_details?.type) === this.mail_type_ids.draft) {
                    to_mails = this.email_data?.mail_details.to_mail
                        ?.replaceAll(' ', '')
                        .split(',') || [];
                } else if (this.email_data?.mail_details?.from_mail) {
                    to_mails = this.email_data?.mail_details?.from_mail
                        ?.replaceAll(' ', '')
                        .split(',') || [];
                }

                if (to_mails?.length) {
                    this.patchEmailField('to', to_mails);
                }

                // Handle CC for draft
                if (this.email_data?.mail_details?.cc_mail) {
                    const cc_mails = this.email_data?.mail_details?.cc_mail
                        ?.replaceAll(' ', '')
                        .split(',');
                    if (cc_mails?.length) {
                        this.patchEmailField('cc', cc_mails);
                    }
                }

                // Handle BCC for draft
                if (this.email_data?.mail_details?.bcc_mail) {
                    const bcc_mails = this.email_data?.mail_details?.bcc_mail
                        ?.replaceAll(' ', '')
                        .split(',');
                    if (bcc_mails?.length) {
                        this.patchEmailField('bcc', bcc_mails);
                    }
                }
            }

            // Handle subject
            if (this.email_data?.mail_details?.subject) {
                if (this.email_data?.type === 'forward') {
                    this.email_data.mail_details.subject =
                        this.email_data?.mail_details?.subject
                            .replace(/(?:^|\s)(fwd:|fw:)/gi, '')
                            .trim();
                    let subject =
                        this.email_data?.mail_details?.subject.includes('Fw:')
                            ? this.email_data?.mail_details?.subject
                            : `Fw: ${this.email_data?.mail_details?.subject}`;
                    this.compose_email_form.get('subject').patchValue(subject);
                } else if (this.email_data?.type === 'draftedit') {
                    let subject = this.email_data?.mail_details?.subject;
                    this.compose_email_form.get('subject').patchValue(subject);
                } else {
                    let subject =
                        this.email_data?.mail_details?.subject.includes('Re:')
                            ? this.email_data?.mail_details?.subject
                            : `Re: ${this.email_data?.mail_details?.subject}`;
                    this.compose_email_form.get('subject').patchValue(subject);
                }
            }

            // Handle content
            if (this.email_data?.type === 'draftedit') {
                this.reply_hidden_content = this.getMailDraftEditBody(
                    this.email_data, this.mailDynamicData
                );
            } else {
                this.reply_hidden_content = this.getMailReplyFormat(
                    this.email_data, this.mailDynamicData
                );
            }

            if (this.reply_hidden_content) {
                this.compose_email_form
                    .get('html')
                    .patchValue(this.reply_hidden_content);
            }

            // Set up email filtering
            this.externalEmailAccessCheck();
        } else {
            let selectedDomain = JSON.parse(
                localStorage.getItem(MailCommon.selected_domain)
            );
            this.compose_email_form.get('from').setValue(selectedDomain?.mail);
        }
    }

    // selectFiles(event: any): void {
    //     let files = event.target.files;
    //     if (calculateSize(files) > 25) {
    //         this.openWarningPopup(MailCommon.large_file);
    //         return;
    //     }
    //     if (files) {
    //         for (let file of files) {
    //             this.upload_files.push(file);
    //         }
    //     }
    // }

    // selectFiles(event: any): void {
    //     const files = event.target.files;
    //     if (files) {
    //         for (const file of files) {
    //             const fileSizeInMB = file.size / (1024 * 1024);
    //             // Skip adding files larger than 25MB
    //             if (fileSizeInMB > 25) {
    //                 this._toasterService.showWarnig(
    //                     'File size exceeds',
    //                     `File ${file.name} exceeds the size limit of 25MB.`
    //                 );
    //                 continue; // Skip this file
    //             }
    //             // Add valid files to the upload listgetPayload
    //             this.upload_files.push(file);
    //         }
    //     }
    //     // Reset the input value to allow selecting the same file again
    //     event.target.value = '';
    // }

    selectFiles(event: any): void {
        const files = event.target.files;
        if (files) {
            // Calculate current total size of existing files in MB
            const existingTotalSize = this.upload_files.reduce((total, file) =>
                total + file.size / (1024 * 1024), 0);

            let newFilesTotalSize = 0;
            const validFiles: File[] = [];

            // First pass: calculate total size of new files
            for (const file of files) {
                const fileSizeInMB = file.size / (1024 * 1024);
                newFilesTotalSize += fileSizeInMB;

                // Check individual file size
                if (fileSizeInMB > this.maxAttachmentSize) {
                    this._toasterService.showWarnig(
                        'File size exceeds',
                        `File ${file.name} exceeds the size limit of ${this.maxAttachmentSize}MB.`
                    );
                    continue;
                }
                validFiles.push(file);
            }

            // Check if total size (existing + new) exceeds 25MB
            if (existingTotalSize + newFilesTotalSize > this.maxAttachmentSize) {
                this._toasterService.showWarnig(
                    'Total size exceeds limit',
                    `Total file size would exceed ${this.maxAttachmentSize}MB limit. Current total: ${existingTotalSize.toFixed(2)}MB, Attempting to add: ${newFilesTotalSize.toFixed(2)}MB`
                );
            } else {
                // Add only valid files if total size is acceptable
                this.upload_files.push(...validFiles);
            }
        }
        // Reset the input value to allow selecting the same file again
        event.target.value = '';
    }

    removeDoc(index: number) {
        this.upload_files.splice(index, 1);
    }

    removeDefaultAttachment(index: number) {
        this.default_attachment.splice(index, 1);
    }

    discard() {
        this.compose_email_form.reset();
        this.upload_files = [];
    }

    getPayload() {
        let to_mail = '';
        let cc_mail = '';
        let bcc_mail = '';
        let html = '';

        let form_values = this.compose_email_form.value;

        if (form_values?.to?.length) {
            form_values?.to?.forEach((element: any, index: number) => {
                if (element?.value) {
                    if (EmailRegex.test(element.value)) {
                        to_mail += `${element.value}${form_values?.to?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                } else {
                    if (EmailRegex.test(element)) {
                        to_mail += `${element}${form_values?.to?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                }
            });
        } else {
            to_mail = form_values?.to;
        }

        if (form_values?.cc?.length) {
            form_values?.cc?.forEach((element: any, index: number) => {
                if (element.value) {
                    if (EmailRegex.test(element.value)) {
                        cc_mail += `${element.value}${form_values?.cc?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                } else {
                    if (EmailRegex.test(element)) {
                        cc_mail += `${element}${form_values?.cc?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                }
            });
        } else {
            cc_mail = form_values?.cc;
        }

        if (form_values?.bcc?.length) {
            form_values?.bcc?.forEach((element: any, index: number) => {
                if (element.value) {
                    if (EmailRegex.test(element.value)) {
                        bcc_mail += `${element.value}${form_values?.bcc?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                } else {
                    if (EmailRegex.test(element)) {
                        bcc_mail += `${element}${form_values?.bcc?.length === index + 1 ? '' : ','
                            }`;
                    } else {
                        this._toasterService.showError('ERROR', 'Invalid mail');
                        return;
                    }
                }
            });
        } else {
            bcc_mail = form_values?.bcc;
        }

        html = this.compose_email_form.value.html;

        let formData = new FormData();
        formData.append('to', to_mail);
        formData.append('cc', cc_mail);
        formData.append('bcc', bcc_mail);
        formData.append('html', html);
        formData.append('subject', form_values?.subject);

        if (this.email_data?.mail_details?.order_id) {
            formData.append('applicationId', this.email_data?.mail_details?.order_id);
            formData.append('referenceId', this.email_data?.mail_details?.id);
            formData.append('showAgent', 'false');
        }

        if (
            this.email_data?.type === 'forward' ||
            this.email_data?.type === 'draftedit'
        ) {
            formData.append(
                'defaultAttachment',
                JSON.stringify(this.default_attachment)
            );
        }

        this.upload_files.forEach((element) => {
            formData.append('attachments', element);
        });

        return formData;
    }

    sendMail() {
        if (this.compose_email_form.invalid) {
            return;
        }

        const isActiveSwitchUser = !!this._lc.getSwitchedUserDetails();
        let parentUserName;
        if(isActiveSwitchUser) {
            parentUserName = JSON.parse(
                localStorage.getItem('user_details')
            )?.name;
        }

        if (this.compose_email_form.value.to.length === 0) {
            this._toasterService.showError(
                'ERROR',
                'This message must have at least one recipient.'
            );
            return;
        }

        this.is_submitted = true;

        let params = '?';
        if (this.compose_email_form.value.from) {
            let selectedMail = this.align_inbox_mail.find(
                (element) => element.mail === this.compose_email_form.value.from
            );
            const find_domain = selectedMail?.domain;
            params += `name=${isActiveSwitchUser?parentUserName:this.user_details?.name}&from=${this.compose_email_form.value.from}&domain=${find_domain}`;
            const inboxEmails = this.user_details.inboxMail.map(email => email.mail);
            const isMailExistsinBox = inboxEmails.includes(selectedMail?.mail);

            if (!isMailExistsinBox) {
                params += `&fromRecipientEmail=${this.user_details?.email}`;
            }
            // if (selectedMail?.isComposeEmail) {
            // }
        }

        if (this.email_data?.mail_details?.order_id) {
            params += `&applicationId=${this.email_data?.mail_details?.order_id}&referenceId=${this.email_data?.mail_details?.id}&showAgent=false`;
        }

        this.paramsForMail = params;
        let formData = this.getPayload();

        if (
            !this.compose_email_form.value.subject &&
            !this.is_subject_missing
        ) {
            this.openWarningPopup(this.mail_common.missing_subject);
            return;
        }

        this._loaderService.showLoader();
        this._universitycommunicationService
            .sendMail(params, formData)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this._loaderService.hideLoader();
                    if (res?.data?.status) {
                        this.is_discard = true;
                        this._toasterService.showSuccess(
                            'SUCCESS',
                            'Email sent successfully'
                        );
                        // this.close(true);
                        this.trigger_reload.emit(true);
                        this.toggleCloseCompose();                        
                    } else {
                        this._toasterService.showError('ERROR!', res?.data?.message);
                    }
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    private startsWithAt(control: FormControl) {
        if (!EmailRegex.test(control.value)) {
            return {
                invalidmail: true,
            };
        }

        return null;
    }

    showCC() {
        this.is_cc = !this.is_cc;
    }

    showBCC() {
        this.is_bcc = !this.is_bcc;
    }

    viewAttachment(file: any) {
        saveAs(file.filePath, file.fileName);
    }

    openWarningPopup(type: string) {
        const isActiveSwitchUser = !!this._lc.getSwitchedUserDetails();
        let parentUserName;
        if(isActiveSwitchUser) {
            parentUserName = JSON.parse(
                localStorage.getItem('user_details')
            )?.name;
        }
        let params = '?';
        if (this.compose_email_form.value.from) {
            let find_domain = this.align_inbox_mail.find(
                (element) => element.mail === this.compose_email_form.value.from
            )?.domain;
            params += `name=${isActiveSwitchUser?parentUserName:this.user_details?.name}&from=${this.compose_email_form.value.from}&domain=${find_domain}`;
        }

        const dialogRef = this._dialog.open(EmailWarningPopupComponent, {
            width: '25%',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            data: {
                formData: this.getPayload(),
                params: params,
                type: type,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result === this.mail_common.discard) {
                    this.is_discard = true;
                    this._universitycommunicationService.checkMails.next(true);
                    this.close();
                } else if (result === this.mail_common.send) {
                    this.is_discard = true;
                    this.is_subject_missing = true;
                    this.sendMail();
                } else {
                    dialogRef.close();
                }
            }
        });
    }

    forbiddenDomainValidator(forbiddenDomain: RegExp) {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const forbidden = forbiddenDomain.test(control.value);
            return forbidden
                ? null
                : {
                    invalidmail: true,
                };
            // { 'forbiddenDomain': { value: control.value } } : null;
        };
    }

    getMailSuggestions(keyDownValue, type: string) {
        this.isLoading[type] = true;
        this._universitycommunicationService
            .getEmailSuggestions(keyDownValue, this.suggestionPaginationConfig)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (rsv) => {
                    this.isLoading[type] = false;
                    let data = rsv?.data;
                    const crizacEmailPattern =
                        /^[a-zA-Z0-9._%+-]+@crizac\.com$/;
                    if (data?.length) {
                        if (type == 'to') {
                            this.suggestions = data.filter((email) => {
                                if (
                                    this.user_details?.externalEmailAccess ==
                                    'true'
                                ) {
                                    return email.includes(keyDownValue);
                                } else {
                                    if (crizacEmailPattern.test(email)) {
                                        return email.includes(keyDownValue);
                                    } else {
                                        return;
                                    }
                                }
                            });
                        } else if (type == 'cc') {
                            this.suggestionsForCC = data.filter((email) => {
                                if (
                                    this.user_details?.externalEmailAccess ==
                                    'true'
                                ) {
                                    return email.includes(keyDownValue);
                                } else {
                                    if (crizacEmailPattern.test(email)) {
                                        return email.includes(keyDownValue);
                                    } else {
                                        return;
                                    }
                                }
                            });
                        } else if (type == 'bcc') {
                            this.suggestionsForBCC = data.filter((email) => {
                                if (
                                    this.user_details?.externalEmailAccess ==
                                    'true'
                                ) {
                                    return email.includes(keyDownValue);
                                } else {
                                    if (crizacEmailPattern.test(email)) {
                                        return email.includes(keyDownValue);
                                    } else {
                                        return;
                                    }
                                }
                            });
                        }
                    } else {
                        this.suggestions = [];
                        this.suggestionsForCC = [];
                        this.suggestionsForBCC = [];
                    }
                },
                () => {
                    this.isLoading[type] = false;
                }
            );
    }

    onKeydown(event: any, type: string): void {
        const inputValue = event?.target?.value;
        this.keydownSubject.next({ inputValue, type });
    }

    addSuggestion(event: MatAutocompleteSelectedEvent, type: string): void {
        const suggestion = event?.option.value;
        if (type == 'to') {
            const currentValue = this.compose_email_form.get('to')?.value;
            this.compose_email_form.patchValue({
                to: [...currentValue, suggestion],
            });
            this.suggestions = []; // Clear suggestions after selection
            this.toInput.nativeElement.value = '';
        } else if (type == 'cc') {
            const currentValue = this.compose_email_form.get('cc')?.value;
            this.compose_email_form.patchValue({
                cc: [...currentValue, suggestion],
            });
            this.suggestionsForCC = []; // Clear suggestions after selection
        } else if (type == 'bcc') {
            const currentValue = this.compose_email_form.get('bcc')?.value;
            this.compose_email_form.patchValue({
                bcc: [...currentValue, suggestion],
            });
            this.suggestionsForBCC = []; // Clear suggestions after selection
        }
    }

    toggleMainimize() {
        this.minimized = !this.minimized;
    }
    toggleCloseCompose() {
        this.compose_email_form.reset();
        this.toggleShowCompose.emit(false);
    }

    toggleMailView() {
        this.createMailWindowState = !this.createMailWindowState;
        if (this.minimized) {
            this.toggleMainimize();
        }
        // this.createMailWindowState ? this.addCssToOverlay() : this.removeCssFromOverlay();
        if (this.createMailWindowState) {
            this.maximize();
        } else {
            this.minimize();
        }
    }
    minimize() {
        this.mailContainer.nativeElement.classList.remove('full-screen');
        document.body.style.overflow = 'auto';
    }
    maximize() {
        this.mailContainer.nativeElement.classList.add('full-screen');
        document.body.style.overflow = 'hidden';
    }

    // Add class to cdk-overlay-container
    addCssToOverlay() {
        const overlayContainer = document.querySelector(
            '.cdk-overlay-container'
        );
        if (
            overlayContainer &&
            overlayContainer.querySelector('.create-mail-box')
        ) {
            // If found, add the custom class to the overlay container
            this.renderer.addClass(overlayContainer, 'custom-overlay-style');
        }
    }

    // Remove class from cdk-overlay-container
    removeCssFromOverlay() {
        const overlayContainer = document.querySelector(
            '.cdk-overlay-container'
        );
        if (overlayContainer) {
            this.renderer.removeClass(overlayContainer, 'custom-overlay-style');
        }
    }

    // contentChanged(event: string) {
    //     if (this.showCompose) {
    //         // Use patchValue instead of setValue to avoid triggering unnecessary validations
    //         this.compose_email_form.get('html')?.patchValue(event, { emitEvent: false });
    //     } else {
    //         this.compose_email_form.get('html')?.reset();
    //         // Only update validity if needed
    //         if (this.compose_email_form.get('html')?.validator) {
    //             this.compose_email_form.get('html')?.updateValueAndValidity();
    //         }
    //     }
    // }

    contentChanged(event: string) {
        if (this.showCompose) {
            // Calculate sizes
            const contentSizeInBytes = new Blob([event]).size;
            const contentSizeInMB = contentSizeInBytes / (1024 * 1024);
            const attachmentSizeInMB = this.upload_files.reduce((total, file) =>
                total + file.size / (1024 * 1024), 0);
            const totalSizeInMB = contentSizeInMB + attachmentSizeInMB;

            // Check if total size exceeds 10MB
            if (totalSizeInMB > 10) {
                this._toasterService.showWarnig(
                    'Content size exceeds limit',
                    `Total email size would exceed 10MB limit. Content: ${contentSizeInMB.toFixed(2)}MB, Attachments: ${attachmentSizeInMB.toFixed(2)}MB`
                );

                // Get the previous valid content
                const previousContent = this.compose_email_form.get('html').value;

                // Update both the form and editor with the previous content
                this.compose_email_form.get('html')?.patchValue(previousContent, { emitEvent: false });

                // Update the Summernote editor content
                if (this.summernoteEditor) {
                    this.summernoteEditor.forceUpdate(previousContent);
                }
                return;
            }

            // Update form if size is acceptable
            this.compose_email_form.get('html')?.patchValue(event, { emitEvent: false });
        } else {
            this.compose_email_form.get('html')?.reset();
            if (this.compose_email_form.get('html')?.validator) {
                this.compose_email_form.get('html')?.updateValueAndValidity();
            }
        }
    }

    add(event: MatChipInputEvent, type: string): void {
        const value = (event.value || '').trim();
        if ((type = 'to')) {
            const currentValue = this.compose_email_form.get('to')?.value;
            this.compose_email_form.patchValue({
                to: [...currentValue, value],
            });

            // Clear the input value
            event.chipInput!.clear();
        }
    }

    remove(index: number, type: string) {
        if (type == 'to') {
            const currentValue = this.compose_email_form.get('to')?.value;
            if (Array.isArray(currentValue)) {
                currentValue.splice(index, 1);
                this.compose_email_form.patchValue({
                    to: [...currentValue],
                });
            }
        }
    }

    get formControls(): AbstractControl | any {
        return this.compose_email_form.controls;
    }

    changedSelection(event) {
        const email = event?.value;
        // First clear the editor
        this.compose_email_form.patchValue({
            html: ''
        });

        // Add a small delay before generating new signature
        setTimeout(() => {
            this.generateSig(email);
            // Force change detection after signature is generated
            this.cdr.detectChanges();
        }, 0);
    }


    generateSig(email) {
        let domain = '';
        if (this.isGlobalMailBox) {
            email = email?.split(',')[0];
            domain = email?.split("@")[1];
        } else {
            domain = email?.split("@")[1];
        }
        let selectedDomain = this.allMailSignatures?.find((signature) => domain?.toLowerCase() == signature?.domain.toLowerCase());
        this.mailDynamicData = {
            companyName: selectedDomain?.companyName ?? "",
            companyWebsite: this.extractDomain(selectedDomain?.companyWebsite) ?? "",
            companyPhone: selectedDomain?.companyPhone ?? "",
            email: this.email_data?.mail_details?.receiptMailId?? email ?? "",
            companyImage: selectedDomain?.companyImage ?? '',
            companyAddress: selectedDomain?.companyAddress ?? ''
        }

        if (this.email_data?.type === 'draftedit') {
            this.compose_email_form?.patchValue({
                html: this.decodeHtml(
                    this.getMailDraftEditBody(
                        this.email_data
                    )
                ),
            });
        } else if ((this.email_data?.type === 'reply') || (this.email_data?.type === 'replyAll')) {
            this.compose_email_form?.patchValue({
                html: //this.decodeHtml(
                    this.getMailReplyFormat(
                        this.email_data, this.mailDynamicData
                    )
                //),
            });
        } else if ((this.email_data?.type === 'forward')) {
            this.compose_email_form?.patchValue({
                html: //this.decodeHtml(
                    this.getMailReplyFormat(
                        this.email_data, this.mailDynamicData
                    )
                //),
            });
        } else {
            this.compose_email_form?.patchValue({
                html: this.decodeHtml(
                    getSignatureWithData(this.email_data, this.user_details, this.mailDynamicData)
                ),
            });
        }
    }

    extractDomain(url) {
        // Remove protocol (http://, https://, etc.)
        let domain = url?.replace(/^https?:\/\//, '');

        // Remove path, query parameters, etc.
        domain = domain?.split('/')[0];

        return domain;
    }

    ngOnDestroy(): void {
        this.editor.destroy();
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
